import React from 'react';
import ReactDOM from 'react-dom';

// Import polyfills.
import 'core-js/fn/array/from';
import 'core-js/fn/array/find-index';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/get-own-property-symbols';
import 'core-js/fn/promise';
import 'core-js/fn/string/repeat';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/symbol';
import 'core-js/fn/set';

import Root from './root';
import './index.css';

ReactDOM.render(
  <Root />,
  document.getElementById('root'),
);

// registerServiceWorker();
